import script from "./FeaturedTranslators.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedTranslators.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedTranslators.vue?vue&type=style&index=0&id=bf18a0c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf18a0c2"]])

export default __exports__